import Blockly from 'blockly';
import { getMsg } from '../Locale.js';

export const codeGenerationDialogs = function () {

    Blockly.JavaScript['get_url_html'] = function (block) {
        const textValue = block.getFieldValue('TEXT');
        const urlValue = block.getFieldValue('URL');
        var code = `"<a href='${urlValue}' target='_blank'>${textValue}</a>"`;
        
        return [code, Blockly.JavaScript.ORDER_NONE];
    };

    Blockly.JavaScript['get_answer'] = function (block) {
        // TODO: Assemble JavaScript into code variable.
        var code = 'getAnswer()';
        // TODO: Change ORDER_NONE to the correct strength.
        return [code, Blockly.JavaScript.ORDER_NONE];
    };

    Blockly.JavaScript['asks'] = function (block) {
        var text_question = Blockly.JavaScript.valueToCode(block, 'QUESTION', Blockly.JavaScript.ORDER_ATOMIC);
        // TODO: Assemble JavaScript into code variable.
        var code = `asks(${text_question});`;
        return code + "\n";
    };

    Blockly.JavaScript['hide'] = function (block) {
        var code = `hide();`;
        return code + "\n";
    }

    Blockly.JavaScript['clear'] = function (block) {
        var code = `clear();`;
        return code + "\n";
    }

    Blockly.JavaScript['show'] = function (block) {
        var value_character = Blockly.JavaScript.valueToCode(block, 'CHARACTER', Blockly.JavaScript.ORDER_ATOMIC);
        var dropdown_animation = block.getFieldValue('ANIMATION');
        var code = `show(${value_character}, "${dropdown_animation}");`;
        return code + "\n";
    }


    Blockly.JavaScript['show_stuff'] = function (block) {
        var value_character = Blockly.JavaScript.valueToCode(block, 'CHARACTER', Blockly.JavaScript.ORDER_ATOMIC);

        var code = `show(${value_character});`;
        return code + "\n";
    }

    Blockly.JavaScript['show_location'] = function (block) {
        var value_location = Blockly.JavaScript.valueToCode(block, 'LOCATION', Blockly.JavaScript.ORDER_ATOMIC);
        var code = `showLocation(${value_location});`;
        return code + "\n";
    }
    Blockly.JavaScript['hide_emotion'] = function (block) {
        var code = `hideEmotion();`;
        return code + "\n";
    }
    Blockly.JavaScript['show_emotion'] = function (block) {
        var value_emotion = Blockly.JavaScript.valueToCode(block, 'EMOTION', Blockly.JavaScript.ORDER_ATOMIC);
        var code = `showEmotion(${value_emotion});`;
        return code + "\n";
    }
    Blockly.JavaScript['says_for_seconds'] = function (block) {

        var value_message = Blockly.JavaScript.valueToCode(block, 'MESSAGE', Blockly.JavaScript.ORDER_ATOMIC);
        //var dropdown_expression = block.getFieldValue('EXPRESSION');
        var seconds = block.getFieldValue('SECONDS');
        // TODO: Assemble JavaScript into code variable.
        var code = `saysForSeconds(${value_message}, ${seconds});
hide();`;
        return code + "\n";
    };
    Blockly.JavaScript['says'] = function (block) {

        var value_message = Blockly.JavaScript.valueToCode(block, 'MESSAGE', Blockly.JavaScript.ORDER_ATOMIC);
        //var dropdown_expression = block.getFieldValue('EXPRESSION');
        // TODO: Assemble JavaScript into code variable.
        var code = `says(${value_message});`;
        return code + "\n";
    };

    Blockly.JavaScript['remove_label'] = function (block) {
        var code = `setLabel();`;
        return code + "\n";
    };

    Blockly.JavaScript['set_label'] = function (block) {

        var value_label = Blockly.JavaScript.valueToCode(block, 'LABEL', Blockly.JavaScript.ORDER_ATOMIC);
        //var dropdown_expression = block.getFieldValue('EXPRESSION');
        // TODO: Assemble JavaScript into code variable.
        var code = `setLabel(${value_label});`;
        return code + "\n";
    };

    Blockly.JavaScript['set_skin'] = function (block) {
        var value_character = Blockly.JavaScript.valueToCode(block, 'CHARACTER', Blockly.JavaScript.ORDER_ATOMIC);
        var dropdown_skintone = block.getFieldValue('SKINTONE');
        // TODO: Assemble JavaScript into code variable.
        var code = `set_skin(${value_character}, "${dropdown_skintone}");`;
        return code + "\n";
    };


    Blockly.JavaScript['get_character'] = function (block) {
        var dropdown_base = block.getFieldValue('BASE');
        var code = `"${dropdown_base}"`;
        return [code, Blockly.JavaScript.ORDER_NONE];
    };

    Blockly.JavaScript['get_location'] = function (block) {
        var dropdown_base = block.getFieldValue('BASE');
        var code = `"${dropdown_base}"`;
        return [code, Blockly.JavaScript.ORDER_NONE];
    };
    Blockly.JavaScript['get_stuff'] = function (block) {
        var dropdown_base = block.getFieldValue('BASE');
        var code = `"${dropdown_base}"`;
        return [code, Blockly.JavaScript.ORDER_NONE];
    };
    Blockly.JavaScript['get_emotion'] = function (block) {
        var dropdown_base = block.getFieldValue('BASE');
        var code = `"${dropdown_base}"`;
        return [code, Blockly.JavaScript.ORDER_NONE];
    };
    Blockly.JavaScript['wait_seconds'] = function (block) {
        var operator = block.getFieldValue('SECONDS');
        var code = `wait(${operator});`;
        return code + "\n";
    };

    Blockly.JavaScript['variables_get_character'] = function (block) {
        // Variable getter.
        var code = Blockly.JavaScript.nameDB_.getName(block.getFieldValue('VAR'),
            Blockly.VARIABLE_CATEGORY_NAME);
        return [code, Blockly.JavaScript.ORDER_ATOMIC];
    };

    Blockly.JavaScript['variables_set_character'] = function (block) {
        // Variable setter.
        var argument0 = Blockly.JavaScript.valueToCode(block, 'VALUE',
            Blockly.JavaScript.ORDER_ASSIGNMENT) || '0';
        var varName = Blockly.JavaScript.nameDB_.getName(
            block.getFieldValue('VAR'), Blockly.VARIABLE_CATEGORY_NAME);
        return varName + ' = ' + argument0 + ';\n';
    };

    Blockly.JavaScript['show_menu'] = function (block) {
        var value_question = Blockly.JavaScript.valueToCode(block, 'QUESTION', Blockly.JavaScript.ORDER_ATOMIC);
        var value_answers = Blockly.JavaScript.valueToCode(block, 'ANSWERS', Blockly.JavaScript.ORDER_ATOMIC);
        // TODO: Assemble JavaScript into code variable.
        var code = `showMenu(${value_question}, ${value_answers ? value_answers : '[]'});`;
        return code + "\n";
    };
    Blockly.JavaScript['rotate_camera'] = function (block) {
        var operator = block.getFieldValue('ANGLE');
        var code = `rotateCamera(${operator});`;
        return code + "\n";
    };
}

export function getBlocks() {
    return [
        {
            "type": "get_url_html",
            "message0": "link %1 🔗 %2",
            "args0": [
                {
                    "type": "field_input",
                    "name": "TEXT",
                    "text": "link text"
                },
                {
                    "type": "field_input",
                    "name": "URL",
                    "text": "https://www.example.com"
                }
            ],
            "output": "String",
            "colour": 160,
            "tooltip": "Return a clickable link with provided text and url",
            "helpUrl": ""
        },
        {
            "type": "rotate_camera",
            "message0": getMsg("ROTATE_CAMERA"),
            "args0": [
                {
                    "type": "field_angle",
                    "name": "ANGLE",
                    "angle": 0
                }
            ],
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_ROTATE_CAMERA"),
            "helpUrl": ""
        },
        {
            "type": "set_label",
            "message0": getMsg("SET_LABEL"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "LABEL",
                    "check": "String"
                }
            ],
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_SET_LABEL"),
            "helpUrl": ""
        },
        {
            "type": "remove_label",
            "message0": getMsg("REMOVE_LABEL"),
            "args0": [],
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_REMOVE_LABEL"),
            "helpUrl": ""
        },
        {
            "type": "show_menu",
            "message0": getMsg("SHOW_MENU_0"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "QUESTION",
                    "check": "String"
                }
            ],
            "message1": getMsg("SHOW_MENU_1"),
            "args1": [
                {
                    "type": "input_value",
                    "name": "ANSWERS",
                    "check": "Array"
                }
            ],
            "previousStatement": null,
            "nextStatement": null,
            "style": "interactivity_blocks",
            "tooltip": getMsg("TOOLTIP_SHOW_MENU"),
            "helpUrl": ""
        },
        {
            "type": "get_answer",
            "message0": getMsg("GET_ANSWER"),
            "output": null,
            "style": "interactivity_blocks",
            "tooltip": getMsg("TOOLTIP_GET_ANSWER"),
            "helpUrl": ""
        },

        {
            "type": "asks",
            "message0": getMsg("ASKS"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "QUESTION",
                    "text": "a question",
                    "check": "String"
                }
            ],
            "inputsInline": false,
            "previousStatement": null,
            "nextStatement": null,
            "style": "interactivity_blocks",
            "tooltip": getMsg("TOOLTIP_ASKS"),
            "helpUrl": ""
        }, {
            "type": "show",
            "message0": getMsg("SHOW"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "CHARACTER",
                    "check": "Character"
                },
                {
                    "type": "field_dropdown",
                    "name": "ANIMATION",
                    "options": [
                        [
                            getMsg("IDLE"), "Idle"
                        ],
                        [
                            getMsg("VICTORY"), "Victory"
                        ],
                        [
                            getMsg("RUN"), "Run"
                        ],
                        [
                            getMsg("WALK"), "Walk"
                        ],
                        [
                            getMsg("DEFEAT"), "Defeat"
                        ],
                        [
                            getMsg("JUMP"), "Jump"
                        ],
                        [
                            getMsg("DEATH"), "Death"
                        ],
                        [
                            getMsg("PUNCH"), "Punch"
                        ],
                        [
                            getMsg("RECEIVEHIT"), "RecieveHit"
                        ]
                    ]
                }
            ],
            "inputsInline": false,
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_SHOW"),
            "helpUrl": ""
        }, {
            "type": "show_stuff",
            "message0": getMsg("SHOW_STUFF"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "CHARACTER",
                    "check": ["Character", "Stuff"]
                }
            ],
            "inputsInline": false,
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_SHOW"),
            "helpUrl": ""
        },
        {
            "type": "show_location",
            "message0": getMsg("SHOW_LOCATION"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "LOCATION",
                    "check": "Location"
                }
            ],
            "inputsInline": false,
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_SHOW_LOCATION"),
            "helpUrl": ""
        },
        {
            "type": "show_emotion",
            "message0": getMsg("SHOW_EMOTION"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "EMOTION",
                    "check": "Emotion"
                }
            ],
            "inputsInline": false,
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_SHOW_EMOTION"),
            "helpUrl": ""
        },
        {
            "type": "says",
            "message0": getMsg("SAYS"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "MESSAGE"
                }
            ],
            "inputsInline": false,
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_SAYS"),
            "helpUrl": ""
        },
        {
            "type": "says_for_seconds",
            "message0": getMsg("SAYS_FOR_SECONDS"),
            "args0": [
                {
                    "type": "input_value",
                    "name": "MESSAGE"
                },
                {
                    "type": "field_number",
                    "name": "SECONDS",
                    "value": "1"
                }
            ],
            "inputsInline": false,
            "previousStatement": null,
            "nextStatement": null,
            "style": "story_blocks",
            "tooltip": getMsg("SAYS_FOR_SECONDS"),
            "helpUrl": ""
        },
        {
            "type": "get_character",
            "message0": getMsg("GET_CHARACTER"),
            "args0": [
                {
                    "type": "field_dropdown",
                    "name": "BASE",
                    "options": [

                    ]

                }
            ],
            "output": 'Character',
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_GET_CHARACTER"),
            "helpUrl": ""
        },
        {
            "type": "get_stuff",
            "message0": getMsg("GET_LOCATION"),
            "args0": [
                {
                    "type": "field_dropdown",
                    "name": "BASE",
                    "options": [

                    ]

                }
            ],
            "output": 'Stuff',
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_GET_LOCATION"),
            "helpUrl": ""
        },
        {
            "type": "get_location",
            "message0": getMsg("GET_LOCATION"),
            "args0": [
                {
                    "type": "field_dropdown",
                    "name": "BASE",
                    "options": [

                    ]

                }
            ],
            "output": 'Location',
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_GET_LOCATION"),
            "helpUrl": ""
        },
        {
            "type": "get_emotion",
            "message0": getMsg("GET_CHARACTER"),
            "args0": [
                {
                    "type": "field_dropdown",
                    "name": "BASE",
                    "options": [

                    ]

                }
            ],
            "output": 'Emotion',
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_GET_CHARACTER"),
            "helpUrl": ""
        },
        {
            "type": "wait_seconds",
            "message0": getMsg("WAIT_SECONDS"),
            "args0": [
                {
                    "type": "field_number",
                    "name": "SECONDS",
                    "value": "1"
                }
            ],
            "tooltip": getMsg("TOOLTIP_WAIT_SECONDS"),
            "style": "story_blocks",
            "nextStatement": null,
            "previousStatement": null,

        },
        {
            "type": "clear",
            "message0": getMsg("CLEAR"),
            "args0": [],
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_CLEAR"),
            "nextStatement": null,
            "previousStatement": null,

        },
        {
            "type": "hide",
            "message0": getMsg("HIDE"),
            "args0": [],
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_HIDE"),
            "nextStatement": null,
            "previousStatement": null,

        },
        {
            "type": "hide_emotion",
            "message0": getMsg("HIDE_EMOTION"),
            "args0": [],
            "style": "story_blocks",
            "tooltip": getMsg("TOOLTIP_HIDE_EMOTION"),
            "nextStatement": null,
            "previousStatement": null,

        },
        {
            "type": "variables_get_character",
            "message0": "%1",
            "args0": [
                {
                    "type": "field_variable",
                    "name": "VAR",
                    "variable": "%{BKY_VARIABLES_DEFAULT_NAME}",
                    "variableTypes": ["Character"],    // Specifies what types to put in the dropdown
                    "defaultType": "Character"
                }
            ],
            "style": "logic_blocks",
            "output": "Character",    // Returns a value of "Character"
        },

        // Block for Character variable setter.
        {
            "type": "variables_set_character",
            "message0": "%{BKY_VARIABLES_SET}",
            "args0": [
                {
                    "type": "field_variable",
                    "name": "VAR",
                    "variable": "%{BKY_VARIABLES_DEFAULT_NAME}",
                    "variableTypes": ["Character"],
                    "defaultType": "Character"
                },
                {
                    "type": "input_value",
                    "name": "VALUE",
                    "check": "Character"    // Checks that the input value is of type "Character"
                }
            ],
            "style": "logic_blocks",
            "previousStatement": null,
            "nextStatement": null
        }
    ];
}


export const DIALOGS = getBlocks();


export const createFlyout = function (workspace) {
    let xmlList = [];
    // Add your button and give it a callback name.
    const button = document.createElement('button');
    button.setAttribute('text', 'Create Character');
    button.setAttribute('callbackKey', 'callbackName');
    workspace.registerButtonCallback('callbackName', (data) => {
        var characterName = prompt("Character name");

        Blockly.Variables.getOrCreateVariablePackage(workspace, null, characterName, 'Character')
        console.log(Blockly.Variables.generateUniqueName(workspace))
    })
    xmlList.push(button);

    // This gets all the variables that the user creates and adds them to the
    // flyout.

    for (let varModel of workspace.getAllVariables()) {
        console.log(varModel)
        if (varModel.type = 'Character') {
            var block = Blockly.utils.xml.createElement('block');
            block.setAttribute('type', 'variables_set_character');
            block.setAttribute('gap', 24);
            block.appendChild(
                Blockly.Variables.generateVariableFieldDom(varModel));
            xmlList.push(block);
        }
    }
    for (let varModel of workspace.getAllVariables()) {
        if (varModel.type == 'Character') {
            var block = Blockly.utils.xml.createElement('block');
            block.setAttribute('type', 'variables_get_character');
            block.setAttribute('gap', 24);
            block.appendChild(
                Blockly.Variables.generateVariableFieldDom(varModel));
            xmlList.push(block);
        }
    }


    return xmlList;
};



const logicBlocks = [
    {
        "kind": "block",
        "type": "controls_if",
        "blockxml": `<block type="controls_if">
        <value name="IF0">
<block type="logic_compare">
<field name="OP">EQ</field>
<value name="A">
<shadow type="get_answer"></shadow>
</value>
<value name="B">
<shadow type="text">
<field name="TEXT"></field>
</shadow>
</value>
</block>
</value>
        </block>`
    },
    {
        "kind": "block",
        "type": "logic_compare"
    },
    {
        "kind": "block",
        "type": "logic_operation"
    },
    {
        "kind": "block",
        "type": "logic_boolean"
    }, {
        "kind": "block",
        "type": "controls_whileUntil"
    }
];



const storyBlocks = [
    {
        "kind": "block",
        "type": "show",
        "blockxml": `<block type="show">
                <value name="CHARACTER">
                <shadow type="get_character"></shadow>
                </value>
                </block>`
    },
    {
        "kind": "block",
        "type": "show_location",
        "blockxml": `<block type="show_location">
                <value name="LOCATION">
                <shadow type="get_location"></shadow>
                </value>
                </block>`
    },
    {
        "kind": "block",
        "type": "show_stuff",
        "blockxml": `<block type="show_stuff">
                <value name="CHARACTER">
                <shadow type="get_stuff"></shadow>
                </value>
                </block>`
    },
    {
        "kind": "block",
        "type": "show_emotion",
        "blockxml": `<block type="show_emotion">
                <value name="EMOTION">
                <shadow type="get_emotion"></shadow>
                </value>
                </block>`
    },
    {
        "kind": "block",
        "type": "says_for_seconds",
        "blockxml": `<block type="says_for_seconds"><value name="MESSAGE"><shadow type="text"></shadow></value></block>`
    },
    {
        "kind": "block",
        "type": "says",
        "blockxml": `<block type="says"><value name="MESSAGE"><shadow type="text"></shadow></value></block>`
    }
    ,
    {
        "kind": "block",
        "type": "wait_seconds"
    },
    {
        "kind": "block",
        "type": "clear"
    },
    {
        "kind": "block",
        "type": "hide"
    },
    {
        "kind": "block",
        "type": "hide_emotion"
    },
    {
        "kind": "block",
        "type": "rotate_camera"
    },
    {
        "kind": "block",
        "type": "set_label",
        "blockxml": `<block type="set_label"><value name="LABEL"><shadow type="text"></shadow></value></block>`
    },
    {
        "kind": "block",
        "type": "remove_label"
    },

]

export const TUTORIAL_TOOLBOX = {
    "kind": "flyoutToolbox",
    "contents": [
        {
            "kind": "label",
            "text": "Story",
            "web-class": "toolbox-labels"
        },
        storyBlocks[0], storyBlocks[1], storyBlocks[2], storyBlocks[3], storyBlocks[4], storyBlocks[5], storyBlocks[6],
        storyBlocks[7], storyBlocks[8], storyBlocks[9], storyBlocks[10], storyBlocks[11], storyBlocks[12],
    ]
}

export const BASIC_TOOLBOX = {
    "kind": "flyoutToolbox",
    "contents": [
        {
            "kind": "label",
            "text": "Story",
            "web-class": "toolbox-labels"
        },
        storyBlocks[0], storyBlocks[1], storyBlocks[2], storyBlocks[3], storyBlocks[4], storyBlocks[5], storyBlocks[6],
        storyBlocks[7], storyBlocks[8], storyBlocks[9], storyBlocks[10], storyBlocks[11], storyBlocks[12],
        {
            "kind": "label",
            "text": "Interactivity",
            "web-class": "toolbox-labels"
        },
        {
            "kind": "block",
            "type": "asks",
            "blockxml": `<block type="asks"><value name="QUESTION"><shadow type="text"></shadow></value></block>`
        },
        {
            "kind": "block",
            "type": "show_menu",
            "blockxml": `
        <block type="show_menu">
            <value name="QUESTION">
                <shadow type="text">
                    <field name="TEXT">${getMsg("SHADOW_QUESTION")}</field>
                </shadow>
            </value>
            <value name="ANSWERS">
                <block type="lists_create_with">
                <mutation items="3"></mutation>
                <!-- <value name="ADD0">
                    <shadow type="text">
                        <field name="TEXT">${getMsg("SHADOW_OPTION_1")}</field>
                    </shadow>
                </value>
                <value name="ADD1">
                    <shadow type="text">
                        <field name="TEXT">${getMsg("SHADOW_OPTION_2")}</field>
                    </shadow>
                </value> -->
            </block>
            </value>
        </block>`
        },
        {
            "kind": "block",
            "type": "get_answer"
        },
        {
            "kind": "block",
            "type": "text"
        },
        {
            "kind": "label",
            "text": "Logic",
            "web-class": "toolbox-labels"
        },
        logicBlocks[0], logicBlocks[1], logicBlocks[2],
        logicBlocks[3], logicBlocks[4],
        {
            "kind": "label",
            "text": "Advanced",
            "web-class": "toolbox-labels"
        }, {
            "kind": "block",
            "type": "get_character"
        },
        {
            "kind": "block",
            "type": "get_stuff"
        },
        {
            "kind": "block",
            "type": "get_location"
        },
        {
            "kind": "block",
            "type": "get_emotion"
        }, {
            "kind": "block",
            "type": "controls_whileUntil"
        },
        {
            "kind": "block",
            "type": "controls_for"
        }
    ]
}

//https://google.github.io/blockly-samples/plugins/content-highlight/test/

export const ADVANCED_TOOLBOX = {
    "kind": "categoryToolbox",
    "contents": [
        {
            "kind": "category",
            "name": "Story",
            "contents": [
                storyBlocks[0], storyBlocks[1], storyBlocks[2], storyBlocks[3], storyBlocks[4], storyBlocks[5], storyBlocks[6],
                storyBlocks[7], storyBlocks[8], storyBlocks[9], storyBlocks[10], storyBlocks[11], storyBlocks[12],
                {
                    "kind": "block",
                    "type": "set_label",
                    "blockxml": `<block type="set_label"><value name="LABEL"><shadow type="text"></shadow></value></block>`
                },
                {
                    "kind": "block",
                    "type": "remove_label"
                },
                {
                    "kind": "block",
                    "type": "get_character"
                }, {
                    "kind": "block",
                    "type": "get_stuff"
                },
                {
                    "kind": "block",
                    "type": "get_location"
                },
                {
                    "kind": "block",
                    "type": "get_emotion"
                },
            ]
        },
        {
            "kind": "category",
            "name": "Interactivity",
            "contents": [
                {
                    "kind": "block",
                    "type": "asks",
                    "blockxml": `<block type="asks"><value name="QUESTION"><shadow type="text"></shadow></value></block>`
                },
                {
                    "kind": "block",
                    "type": "show_menu",
                    "blockxml": `
                <block type="show_menu">
                    <value name="QUESTION">
                        <shadow type="text">
                            <field name="TEXT">${getMsg("SHADOW_QUESTION")}</field>
                        </shadow>
                    </value>
                    <value name="ANSWERS">
                        <block type="lists_create_with">
                        <mutation items="3"></mutation>
                        <!-- <value name="ADD0">
                            <shadow type="text">
                                <field name="TEXT">${getMsg("SHADOW_OPTION_1")}</field>
                            </shadow>
                        </value>
                        <value name="ADD1">
                            <shadow type="text">
                                <field name="TEXT">${getMsg("SHADOW_OPTION_2")}</field>
                            </shadow>
                        </value> -->
                    </block>
                    </value>
                </block>`
                },
                {
                    "kind": "block",
                    "type": "get_answer"
                },
                {
                    "kind": "block",
                    "type": "text"
                },
                {
                    "kind": "block",
                    "type": "text_multiline"
                },
                {
                    'kind': 'block',
                    'type': 'get_url_html',
                },
                {
                    'kind': 'block',
                    "type": "text_join",
                    "extraState": {
                        "itemCount": 2
                    },
                    "inputs": {
                        "ADD0": {
                            "block": {
                                "type": "text",
                                "fields": {
                                    "TEXT": ""
                                }
                            }
                        },
                        "ADD1": {
                            "block": {
                                "type": "text",
                                "fields": {
                                    "TEXT": ""
                                }
                            }
                        }
                    }
                }
            ]
        },
        {
            "kind": "category",
            "name": "Logic",
            "contents": logicBlocks
        },
        {
            "kind": "category",
            "name": "Math",
            "contents": [
                {
                    "kind": "block",
                    "type": "math_number",
                    "fields": {
                        "NUM": 42
                    }
                },
                {
                    "kind": "block",
                    "type": "math_arithmetic",
                    "fields": {
                        "OP": "ADD"
                    },
                    "inputs": {
                        "A": {
                            "shadow": {
                                "type": "math_number",
                                "fields": {
                                    "NUM": 1
                                }
                            }
                        },
                        "B": {
                            "shadow": {
                                "type": "math_number",
                                "fields": {
                                    "NUM": 1
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "block",
                    "type": "math_single",
                    "fields": {
                        "OP": "ADD"
                    }
                },
                {
                    "kind": "block",
                    "type": "math_number_property",
                    "fields": {
                        "PROPERTY": "EVEN"
                    }
                },
                {
                    "kind": "block",
                    "type": "math_modulo"
                },
                {
                    "kind": "block",
                    "type": "math_random_float"
                },
            ]
        },
        // {
        //     "kind": "category",
        //     "name": "Characters",
        //     "custom": "CREATE_TYPED_VARIABLE"
        // },
        {
            "kind": "category",
            "name": "Functions",
            "custom": "PROCEDURE"
        },
        {
            "kind": "category",
            "name": "Variables",
            "custom": "VARIABLE"
        }
    ]
}
